import 'angular';
import '@uirouter/angular-hybrid';
